import React from "react";

import { Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";

class AddAllowedUrlDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValidTest: true,
      testString: "",
      validation: ValidationHelper.getValidation({
        url: {
          defaultValue: "",
          initValid: false,
          rule: ValidationHelper.isRegEx
        }
      })
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    let isValid = false;
    if (event.target.name === "testString") {
      try {
        isValid = new RegExp(this.state.validation.url.value).test(
          event.target.value
        );
      } catch (err) {
        console.log(err);
      }
      this.setState({
        testString: event.target.value,
        isValidTest: this.state.validation.url.isValid && isValid
      });
    } else {
      const validation = ValidationHelper.update(event, this.state.validation);
      try {
        isValid = new RegExp(validation.url.value).test(this.state.testString);
      } catch (err) {
        console.log(err);
      }
      this.setState({
        validation: validation,
        isValidTest: validation.url.isValid && isValid
      });
    }
  }

  render() {
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.props.onHide}
        size="xs"
        title={this.props.t("SingleNetworkProfile.AllowedUrlsTab.AddModal.Title")}
        dialogApiError={this.props.dialogApiError}
        leftButtonCallback={() => this.props.onSubmit(this.state.validation.url.value)}
        leftButtonVariant="green"
        leftButtonText={this.props.t("SingleNetworkProfile.AllowedUrlsTab.AddModal.Add")}
        leftButtonDisabled={!this.state.validation.url.isValid}
        rightButtonCallback={this.props.onHide}
        rightButtonText={this.props.t("DialogCancel")}
        rightButtonVariant="black"
        body={(<>
          <Form.Group>
            <Form.Label>
              <b>{this.props.t(
                "SingleNetworkProfile.AllowedUrlsTab.AddModal.Form.RegEx"
              )}</b>
            </Form.Label>
            <Form.Control
              type="text"
              name="url"
              onChange={this.handleChange}
              placeholder={this.props.t(
                "SingleNetworkProfile.AllowedUrlsTab.AddModal.Form.RegExPlaceholder"
              )} />
          </Form.Group><hr /><Form.Group>
            <Form.Label>
              {this.props.t(
                "SingleNetworkProfile.AllowedUrlsTab.AddModal.Form.TestString"
              )}
            </Form.Label>
            <Form.Control
              type="text"
              name="testString"
              isInvalid={!this.state.isValidTest}
              isValid={this.state.isValidTest}
              onChange={this.handleChange} />
          </Form.Group>
          </>)}
      />
    );
  }
}

export default withTranslation()(AddAllowedUrlDialog);
